var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { removeSessionStoragePrefs } from "../../Storage";
import { OPENED_CHAT } from "../../globals";
var IrrelevantNode = function (props) {
    var back = function () {
        removeSessionStoragePrefs(OPENED_CHAT);
        removeSessionStoragePrefs("flow_execution_id");
        // props.backToHome();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsx("span", __assign({ className: "actual" }, { children: props.content })) })) })) })) })), _jsx("div", __assign({ className: "chat__messages-group--me" }, { children: _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "multi_choice-list-item-btn", onClick: function () { return back(); } }, { children: _jsx("span", __assign({ className: "actual" }, { children: "Back to home" })) })) })) }))] }));
};
export default IrrelevantNode;
